export default __webpack_public_path__ + "static/shop-shorts-3f3f4275e7a64cbf9cf16bd58af67f8a.jpg";